export class WorkingDayProperty {
  public weekDay: number;
  public startAm: any; // "HH:mm"
  public endAm: any; // "HH:mm"
  public startPm: any; // "HH:mm"
  public endPm: any; // "HH:mm"
}
